import update from 'immutability-helper';

import {
  DateMaker
} from "../../helpers";
import {
  buildRotatingDigests,
} from '../../helpers/DateMaker';

import {
  SET_BUCKETS,
  SET_TILES,
  REMOVE_TILE,
  REMOVE_TILES,
  COPY_TILE,
  TOGGLE_TILE_LOADING,
  UPDATE_TILE,
  MOVE_TILES_TO_STATE,
  TOGGLE_TILE_IGNORE,
  UPDATE_BUCKET_TILES,
} from '../actionTypes';

const initialBuckets = buildRotatingDigests();

const initialState = {
  tiles: {
    active: { tiles: [], count: 0 },
    archive: { tiles: [], count: 0 },
    draft: { tiles: [], count: 0 },
    ignored: { tiles: [], count: 0 },
    plan: { tiles: [], count: 0 },
    user_submitted: { tiles: [], count: 0 },
  },
  buckets: initialBuckets,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_BUCKETS: {
      return {
        ...state,
        buckets: { ...action.payload },
      }
    }
    case UPDATE_BUCKET_TILES: {
      const { digestDate, tiles } = action.payload;
      const previousBuckets = state.buckets;
      const monthBucket = moment(digestDate, 'YYYY-MM-DD').format('YYYY-MM');
      const bucket = previousBuckets[monthBucket];
      const updatedBucket = update(bucket, {
        digests: {
          [digestDate]: {
            tiles: {
              $set: tiles
            }
          }
        }
      });
      const tileCount = Object
        .values(updatedBucket.digests)
        .reduce((acc, digest) => acc + digest.tiles.length , 0);

      const newBuckets = update(previousBuckets, {
        [monthBucket]: {
          $merge: { ...updatedBucket, tileCount }
        }
      });

      return {
        ...state,
        buckets: newBuckets,
      };
    }
    case REMOVE_TILE: {
      const { ignored, status, id } = action.payload;
      const previousTiles = { ...state.tiles };
      const tileStatus = ignored ? 'user_submitted' : status;
      const newTiles = previousTiles[tileStatus].tiles.filter(
        item => item.id !== id,
      );
      const tiles = update(previousTiles, {
        [tileStatus]: {
          count: { $set: newTiles.length },
          tiles: { $set: newTiles },
        },
      });

      return {
        ...state,
        tiles,
      };
    }
    case REMOVE_TILES: {
      const { tilesIds, status } = action.payload;
      const previousTiles = { ...state.tiles };
      const newTiles = previousTiles[status].tiles.filter(
        item => !tilesIds.includes(item.id)
      );
      const tiles = update(previousTiles, {
        [status]: {
          count: { $set: newTiles.length },
          tiles: { $set: newTiles },
        }
      });

      return {
        ...state,
        tiles: tiles
      }
    }
    case SET_TILES: {
      return {
        ...state,
        tiles: { ...state.tiles, ...action.payload },
      }
    }
    case TOGGLE_TILE_LOADING: {
      const { tileId, activeStatus } = action.payload;
      const previousTiles = { ...state.tiles };
      const stateTiles = previousTiles[activeStatus].tiles;
      const currentTile = stateTiles.find((tile) => tile.id === tileId);
      const tileIndex = stateTiles.indexOf(currentTile);

      stateTiles[tileIndex].loading = !stateTiles[tileIndex].loading;

      const tiles = update(previousTiles, {
        [activeStatus]: {
          count: { $set: stateTiles.length },
          tiles: { $set: stateTiles }
        }
      });

      return {
        ...state,
        tiles
      }
    }
    case TOGGLE_TILE_IGNORE: {
      const { tileId, activeStatus } = action.payload;
      const previousTiles = { ...state.tiles };
      const stateTiles = previousTiles[activeStatus].tiles;
      const currentTile = stateTiles.find((tile) => tile.id === tileId);
      const tileIndex = stateTiles.indexOf(currentTile);

      stateTiles[tileIndex].ignored = !stateTiles[tileIndex].ignored;

      const tiles = update(previousTiles, {
        [activeStatus]: {
          count: { $set: stateTiles.length },
          tiles: { $set: stateTiles }
        }
      });

      return {
        ...state,
        tiles
      }
    }
    case UPDATE_TILE: {
      const { tile, activeStatus } = action.payload;
      const previousTiles = { ...state.tiles };
      const stateTiles = previousTiles[activeStatus].tiles;
      const currentTile = stateTiles.find((t) => t.id === tile.id);
      const tileIndex = stateTiles.indexOf(currentTile);

      stateTiles[tileIndex] = tile;

      const tiles = update(previousTiles, {
        [activeStatus]: {
          count: { $set: stateTiles.length },
          tiles: { $set: stateTiles }
        }
      });

      return {
        ...state,
        tiles
      }
    }
    case COPY_TILE: {
      const { tile } = action.payload;
      const tiles = { ...state.tiles };

      tiles.plan.tiles.unshift(tile);
      tiles.plan.count += 1;

      return {
        ...state,
        tiles: { ...tiles }
      }
    }
    case MOVE_TILES_TO_STATE: {
      const { response: newTiles, tilesIds, currentState, newState } = action.payload;
      const previousTiles = { ...state.tiles };
      const stateTiles = previousTiles[newState].tiles;
      const newStateTiles = newTiles.concat(stateTiles);
      const newCurrentStateTiles = previousTiles[currentState].tiles.filter(
        item => !tilesIds.includes(item.id)
      );
      const tiles = update(previousTiles, {
        [newState]: {
          count: { $set: newStateTiles.length },
          tiles: { $set: newStateTiles },
        },
        [currentState]: {
          count: { $set: newCurrentStateTiles.length },
          tiles: { $set: newCurrentStateTiles },
        },
      });

      return {
        ...state,
        tiles: { ...tiles },
      };
    }
    default: {
      return state;
    }
  }
}
